import single_parent1 from '../assets/personas/single_parent1.jpg';
import commuter1 from '../assets/personas/commuter1.jpg';
import shift_worker1 from '../assets/personas/shift_worker1.jpg';
import cook1 from '../assets/personas/cook1.jpg';
import cook2 from '../assets/personas/cook2.jpg';
import cook3 from '../assets/personas/cook3.jpg';
import elderly_man1 from '../assets/personas/elderly_man1.jpg';
import elderly_man2 from '../assets/personas/elderly_man2.jpg';
import elderly_man3 from '../assets/personas/elderly_man3.jpg';
import elderly_man4 from '../assets/personas/elderly_man4.jpg';
import farmer1 from '../assets/personas/farmer1.jpg';
import farmer2 from '../assets/personas/farmer2.jpg';
import farmer3 from '../assets/personas/farmer3.jpg';
import female_student1 from '../assets/personas/female_student1.jpg';
import female_student2 from '../assets/personas/female_student2.jpg';
import nurse1 from '../assets/personas/nurse1.jpg';
import nurse2 from '../assets/personas/nurse2.jpg';
import nurse3 from '../assets/personas/nurse3.jpg';
import nurse4 from '../assets/personas/nurse4.jpg';
import young_mother1 from '../assets/personas/young_mother1.jpg';
import young_mother2 from '../assets/personas/young_mother2.jpg';
import young_mother3 from '../assets/personas/young_mother3.jpg';
import young_mother4 from '../assets/personas/young_mother4.jpg';
import elderly_man_wheelchair1 from '../assets/personas/elderly_man_wheelchair1.jpg';
import elderly_man_wheelchair2 from '../assets/personas/elderly_man_wheelchair2.jpg';
import elderly_man_wheelchair3 from '../assets/personas/elderly_man_wheelchair3.jpg';
import middle_aged_male_truck_driver1 from '../assets/personas/middle_aged_male_truck_driver1.jpg';
import middle_aged_male_truck_driver2 from '../assets/personas/middle_aged_male_truck_driver2.jpg';
import middle_aged_male_truck_driver3 from '../assets/personas/middle_aged_male_truck_driver3.jpg';
import middle_aged_male_truck_driver4 from '../assets/personas/middle_aged_male_truck_driver4.jpg';
import male_indian_student1 from '../assets/personas/male_indian_student1.jpg';
import male_indian_student2 from '../assets/personas/male_indian_student2.jpg';
import male_indian_student3 from '../assets/personas/male_indian_student3.jpg';
import male_indian_student4 from '../assets/personas/male_indian_student4.jpg';
import female_worker_with_laptop1 from '../assets/personas/female_worker_with_laptop1.jpg';
import female_worker_with_laptop2 from '../assets/personas/female_worker_with_laptop2.jpg';
import female_worker_with_laptop3 from '../assets/personas/female_worker_with_laptop3.jpg';
import female_worker_with_laptop4 from '../assets/personas/female_worker_with_laptop4.jpg';
import families1 from '../assets/personas/families1.jpg';
import families2 from '../assets/personas/families2.jpg';
import families3 from '../assets/personas/families3.jpg';
import families4 from '../assets/personas/families4.jpg';
import families5 from '../assets/personas/families5.jpg';
import families6 from '../assets/personas/families6.jpg';
import families7 from '../assets/personas/families7.jpg';
import families8 from '../assets/personas/families8.jpg';
import families9 from '../assets/personas/families9.jpg';
import families10 from '../assets/personas/families10.jpg';
import families11 from '../assets/personas/families11.jpg';
import families12 from '../assets/personas/families12.jpg';
import families13 from '../assets/personas/families13.jpg';
import families14 from '../assets/personas/families14.jpg';
import families15 from '../assets/personas/families15.jpg';
import female_speaker1 from '../assets/personas/female_speaker1.jpg';
import female_speaker2 from '../assets/personas/female_speaker2.jpg';
import female_speaker3 from '../assets/personas/female_speaker3.jpg';
import female_speaker4 from '../assets/personas/female_speaker4.jpg';
import construction_worker1 from '../assets/personas/construction_worker1.jpg';
import construction_worker2 from '../assets/personas/construction_worker2.jpg';
import construction_worker3 from '../assets/personas/construction_worker3.jpg';
import construction_worker4 from '../assets/personas/construction_worker4.jpg';
import elderly_woman_wheelchair1 from '../assets/personas/elderly_woman_wheelchair1.jpg';
import elderly_woman_wheelchair2 from '../assets/personas/elderly_woman_wheelchair2.jpg';
import elderly_woman_wheelchair3 from '../assets/personas/elderly_woman_wheelchair3.jpg';
import elderly_woman_wheelchair4 from '../assets/personas/elderly_woman_wheelchair4.jpg';
import female_teacher1 from '../assets/personas/female_teacher1.jpg';
import female_teacher2 from '../assets/personas/female_teacher2.jpg';
import male_teacher1 from '../assets/personas/male_teacher1.jpg';
import male_teacher2 from '../assets/personas/male_teacher2.jpg';
import male_zzp1 from '../assets/personas/male_zzp1.jpg';
import male_zzp2 from '../assets/personas/male_zzp2.jpg';
import male_zzp3 from '../assets/personas/male_zzp3.jpg';
import male_zzp4 from '../assets/personas/male_zzp4.jpg';
import business_woman1 from '../assets/personas/business_woman1.jpg';
import business_woman2 from '../assets/personas/business_woman2.jpg';
import business_woman3 from '../assets/personas/business_woman3.jpg';
import business_woman4 from '../assets/personas/business_woman4.jpg';
import climate_girl1 from '../assets/personas/climate_girl1.jpg';
import climate_girl2 from '../assets/personas/climate_girl2.jpg';
import climate_girl3 from '../assets/personas/climate_girl3.jpg';
import climate_girl4 from '../assets/personas/climate_girl4.jpg';
import taxi_driver1 from '../assets/personas/taxi_driver1.jpg';
import taxi_driver2 from '../assets/personas/taxi_driver2.jpg';
import taxi_driver3 from '../assets/personas/taxi_driver3.jpg';
import taxi_driver4 from '../assets/personas/taxi_driver4.jpg';
import tech_guy1 from '../assets/personas/tech_guy1.jpg';
import tech_guy2 from '../assets/personas/tech_guy2.jpg';
import tech_guy3 from '../assets/personas/tech_guy3.jpg';
import tech_guy4 from '../assets/personas/tech_guy4.jpg';
import middleaged_man_suit1 from '../assets/personas/middleaged_man_suit1.jpg';
import middleaged_man_suit2 from '../assets/personas/middleaged_man_suit2.jpg';
import middleaged_man_suit3 from '../assets/personas/middleaged_man_suit3.jpg';
import middleaged_man_suit4 from '../assets/personas/middleaged_man_suit4.jpg';

export const PersonaImages = [
  { id: 'single_parent1', img: single_parent1, label: 'Single parent' },
  { id: 'commuter1', img: commuter1, label: 'Commuter' },
  { id: 'shift_worker1', img: shift_worker1, label: 'Plant shift worker' },
  { id: 'cook1', img: cook1, label: 'Restaurant cook' },
  { id: 'cook2', img: cook2, label: 'Cook 2' },
  { id: 'cook3', img: cook3, label: 'Cook 3' },
  {
    id: 'elderly_man1',
    img: elderly_man1,
    label: 'Older person living alone',
  },
  {
    id: 'elderly_man2',
    img: elderly_man2,
    label: 'Elderly man 2',
  },
  {
    id: 'elderly_man3',
    img: elderly_man3,
    label: 'Elderly man 3',
  },
  {
    id: 'elderly_man4',
    img: elderly_man4,
    label: 'Elderly man 4',
  },
  {
    id: 'farmer1',
    img: farmer1,
    label: 'Farmer',
  },
  {
    id: 'farmer2',
    img: farmer2,
    label: 'Farmer 2',
  },
  {
    id: 'farmer3',
    img: farmer3,
    label: 'Farmer 3',
  },
  {
    id: 'female_student1',
    img: female_student1,
    label: 'Student',
  },
  {
    id: 'female_student2',
    img: female_student2,
    label: 'Female student 2',
  },
  {
    id: 'nurse1',
    img: nurse1,
    label: 'Hospital nurse',
  },
  {
    id: 'nurse2',
    img: nurse2,
    label: 'Nurse 2',
  },
  {
    id: 'nurse3',
    img: nurse3,
    label: 'Nurse 3',
  },
  {
    id: 'nurse4',
    img: nurse4,
    label: 'Nurse 4',
  },
  {
    id: 'young_mother1',
    img: young_mother1,
    label: 'Parent of young children',
  },
  {
    id: 'young_mother2',
    img: young_mother2,
    label: 'Young mother 2',
  },
  {
    id: 'young_mother3',
    img: young_mother3,
    label: 'Young mother 3',
  },
  {
    id: 'young_mother4',
    img: young_mother4,
    label: 'Young mother 4',
  },
  {
    id: 'elderly_man_wheelchair1',
    img: elderly_man_wheelchair1,
    label: 'Elderly man in wheelchair 1',
  },
  {
    id: 'elderly_man_wheelchair2',
    img: elderly_man_wheelchair2,
    label: 'Elderly man in wheelchair 2',
  },
  {
    id: 'elderly_man_wheelchair3',
    img: elderly_man_wheelchair3,
    label: 'Elderly man in wheelchair 3',
  },
  {
    id: 'middle_aged_male_truck_driver1',
    img: middle_aged_male_truck_driver1,
    label: 'Truck driver',
  },
  {
    id: 'middle_aged_male_truck_driver2',
    img: middle_aged_male_truck_driver2,
    label: 'Middle-aged male truckdriver 2',
  },
  {
    id: 'middle_aged_male_truck_driver3',
    img: middle_aged_male_truck_driver3,
    label: 'Middle-aged male truckdriver 3',
  },
  {
    id: 'middle_aged_male_truck_driver4',
    img: middle_aged_male_truck_driver4,
    label: 'Middle-aged male truckdriver 4',
  },
  {
    id: 'male_indian_student1',
    img: male_indian_student1,
    label: 'International traveller',
  },
  {
    id: 'male_indian_student2',
    img: male_indian_student2,
    label: 'Male Indian student 2',
  },
  {
    id: 'male_indian_student3',
    img: male_indian_student3,
    label: 'Male Indian student 3',
  },
  {
    id: 'male_indian_student4',
    img: male_indian_student4,
    label: 'Male Indian student 4',
  },
  {
    id: 'female_worker_with_laptop1',
    img: female_worker_with_laptop1,
    label: 'Event organiser',
  },
  {
    id: 'female_worker_with_laptop2',
    img: female_worker_with_laptop2,
    label: 'Female worker with laptop 2',
  },
  {
    id: 'female_worker_with_laptop3',
    img: female_worker_with_laptop3,
    label: 'Female worker with laptop 3',
  },
  {
    id: 'female_worker_with_laptop4',
    img: female_worker_with_laptop4,
    label: 'Female worker with laptop 4',
  },
  { id: 'families1', img: families1, label: 'Event visitor' },
  { id: 'families2', img: families2, label: 'Nearby residents' },
  { id: 'families3', img: families3, label: 'Families 3' },
  { id: 'families4', img: families4, label: 'Families 4' },
  { id: 'families5', img: families5, label: 'Families 5' },
  { id: 'families6', img: families6, label: 'Families 6' },
  { id: 'families7', img: families7, label: 'Families 7' },
  { id: 'families8', img: families8, label: 'Families 8' },
  { id: 'families9', img: families9, label: 'Families 9' },
  { id: 'families10', img: families10, label: 'Families 10' },
  { id: 'families11', img: families11, label: 'Families 11' },
  { id: 'families12', img: families12, label: 'Families 12' },
  { id: 'families13', img: families13, label: 'Families 13' },
  { id: 'families14', img: families14, label: 'Families 14' },
  { id: 'families15', img: families15, label: 'Families 15' },
  { id: 'female_speaker1', img: female_speaker1, label: 'Community leader' },
  { id: 'female_speaker2', img: female_speaker2, label: 'Female speaker 2' },
  { id: 'female_speaker3', img: female_speaker3, label: 'Female speaker 3' },
  { id: 'female_speaker4', img: female_speaker4, label: 'Female speaker 4' },
  {
    id: 'construction_worker1',
    img: construction_worker1,
    label: 'Construction and utility worker',
  },
  {
    id: 'construction_worker2',
    img: construction_worker2,
    label: 'Construction worker 2',
  },
  {
    id: 'construction_worker3',
    img: construction_worker3,
    label: 'Construction worker 3',
  },
  {
    id: 'construction_worker4',
    img: construction_worker4,
    label: 'Construction worker 4',
  },
  {
    id: 'elderly_woman_wheelchair1',
    img: elderly_woman_wheelchair1,
    label: 'Resident with reduced mobility',
  },
  {
    id: 'elderly_woman_wheelchair2',
    img: elderly_woman_wheelchair2,
    label: 'Elderly woman in wheelchair 2',
  },
  {
    id: 'elderly_woman_wheelchair3',
    img: elderly_woman_wheelchair3,
    label: 'Elderly woman in wheelchair 3',
  },
  {
    id: 'elderly_woman_wheelchair4',
    img: elderly_woman_wheelchair4,
    label: 'Elderly woman in wheelchair 4',
  },
  { id: 'female_teacher1', img: female_teacher1, label: 'Teacher' },
  { id: 'female_teacher2', img: female_teacher2, label: 'Female teacher 2' },
  { id: 'male_teacher1', img: male_teacher1, label: 'Male teacher 1' },
  { id: 'male_teacher2', img: male_teacher2, label: 'Male teacher 2' },
  { id: 'male_zzp1', img: male_zzp1, label: 'Small business owner' },
  { id: 'male_zzp2', img: male_zzp2, label: 'Male worker with laptop' },
  { id: 'male_zzp3', img: male_zzp3, label: 'Male worker with laptop' },
  { id: 'male_zzp4', img: male_zzp4, label: 'Male worker with laptop' },
  { id: 'business_woman1', img: business_woman1, label: 'Infrastructure operator' },
  { id: 'business_woman2', img: business_woman2, label: 'Business woman 2' },
  { id: 'business_woman3', img: business_woman3, label: 'Business woman 3' },
  { id: 'business_woman4', img: business_woman4, label: 'Business woman 4' },
  { id: 'climate_girl1', img: climate_girl1, label: 'Student protester' },
  { id: 'climate_girl2', img: climate_girl2, label: 'Climate girl 2' },
  { id: 'climate_girl3', img: climate_girl3, label: 'Climate girl 3' },
  { id: 'climate_girl4', img: climate_girl4, label: 'Climate girl 4' },
  { id: 'taxi_driver1', img: taxi_driver1, label: 'Taxi driver' },
  { id: 'taxi_driver2', img: taxi_driver2, label: 'Taxi driver 2' },
  { id: 'taxi_driver3', img: taxi_driver3, label: 'Taxi driver 3' },
  { id: 'taxi_driver4', img: taxi_driver4, label: 'Taxi driver 4' },
  { id: 'tech_guy1', img: tech_guy1, label: 'IT security specialist' },
  { id: 'tech_guy2', img: tech_guy2, label: 'Tech guy 2' },
  { id: 'tech_guy3', img: tech_guy3, label: 'Tech guy 3' },
  { id: 'tech_guy4', img: tech_guy4, label: 'Tech guy 4' },
  {
    id: 'middleaged_man_suit1',
    img: middleaged_man_suit1,
    label: 'Local official',
  },
  {
    id: 'middleaged_man_suit2',
    img: middleaged_man_suit2,
    label: 'Middleaged man in suit 2',
  },
  {
    id: 'middleaged_man_suit3',
    img: middleaged_man_suit3,
    label: 'Middleaged man in suit 3',
  },
  {
    id: 'middleaged_man_suit4',
    img: middleaged_man_suit4,
    label: 'Middleaged man in suit 4',
  },
];
